import { Component, OnInit, AfterViewInit } from '@angular/core';

@Component({
  selector: 'loyaltic-survey-script',
  templateUrl: './survey-script.component.html',
  styleUrls: ['./survey-script.component.scss']
})
export class SurveyScriptComponent implements OnInit, AfterViewInit {

  constructor() { }


  ngAfterViewInit(): void {
    if (localStorage.getItem("authMarket") === 'se') {
      const script = document.createElement('script');
      // tslint:disable-next-line: max-line-length
      script.src = 'https://widget.surveymonkey.com/collect/website/js/tRaiETqnLgj758hTBazgd8ads510KgEXg7JcNF6bc7PmH1FOWKphnEc9_2F_2BMR1fLC.js'
      document.getElementById('smcx-sdk').appendChild(script);
    } else if (localStorage.getItem("authMarket") === 'fi') {
      const script = document.createElement('script');
      // tslint:disable-next-line: max-line-length
      script.src = 'https://widget.surveymonkey.com/collect/website/js/tRaiETqnLgj758hTBazgd8Pfs5OAAlQ1VNOJ8hmUOk8F5q8fJQ45F2C7SFkNenS7.js'
      document.getElementById('smcx-sdk').appendChild(script);
    }

  }

  ngOnInit() {
  }

}
